import axios from "@/libs/api.request";

// 获取仓库管理的列表
export const getWarehouse = params => {
  return axios.request({
    url: "/warehouse/warehouse",
    method: "get",
    params
  });
};
// 获取仓库管理的详情
export const getDetails = id => {
  return axios.request({
    url: `/warehouse/warehouse/${id}`,
    method: "GET"
  });
};
// 删除仓库管理的记录
export const del = id => {
  return axios.request({
    url: `/warehouse/warehouse/${id}`,
    method: "DELETE"
  });
};
// 更新仓库管理的记录
export const update = data => {
  return axios.request({
    url: `/warehouse/warehouse/${data.id}`,
    method: "PUT",
    data
  });
};
// 创建仓库管理的记录
export const add = data => {
  return axios.request({
    url: "/warehouse/warehouse",
    method: "POST",
    data
  });
};
